"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _lodash = _interopRequireDefault(require("lodash"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var _BouncerMiddleware = _interopRequireDefault(require("@/libs/BouncerMiddleware"));
var log = _Logger.default.namespace('BouncerProvider.js');
var BouncerProvider = exports.default = /*#__PURE__*/function () {
  function BouncerProvider(state) {
    (0, _classCallCheck2.default)(this, BouncerProvider);
    this.state = state;

    // This is the network that will be used to control the bouncer
    this.controllerNetwork = null;

    // The detected credentials for the BNC
    this.bnc = {
      enabled: false,
      username: '',
      password: '',
      server: '',
      port: 6667,
      tls: false,
      direct: false,
      path: '',
      registered: false
    };

    // If enabled, new IRC connections will be re-routed through the bouncer
    this.rewriteConnections = true;

    // A snapshot of the current networks. Compared against to detect changed networks
    this.networksSnapshot = Object.create(null);

    // If we are currently monitoring for network settings changes
    this.monitoringChanges = false;
    state.$on('irc.motd', this.onNetworkMotd.bind(this));
    state.$on('irc.bouncer state', this.onNetworkState.bind(this));
    state.$on('irc.bouncer networks', this.onBouncerNetworks.bind(this));
  }
  return (0, _createClass2.default)(BouncerProvider, [{
    key: "enable",
    value: function enable(server, port, tls, direct, path) {
      var _context, _context2, _bncNetwork$connectio;
      log((0, _concat.default)(_context = "Using a Bouncer Provider with server ".concat(server, ":")).call(_context, port));
      this.bnc.server = server;
      this.bnc.port = port || 6667;
      this.bnc.tls = !!tls;
      this.bnc.direct = !!direct;
      this.bnc.path = path || '';
      this.bnc.enabled = true;

      // get the bnc controller network
      var bncNetwork = (0, _find.default)(_context2 = this.state.networks).call(_context2, function (network) {
        return network.is_bnc;
      });

      // the bnc controller network password is saved in the format <username>:<password>.
      // if there is a bnc controller network with a password, use these credentials
      // for the bnc connection.
      if (bncNetwork !== null && bncNetwork !== void 0 && (_bncNetwork$connectio = bncNetwork.connection) !== null && _bncNetwork$connectio !== void 0 && _bncNetwork$connectio.password) {
        var _this$parseBncCredent = this.parseBncCredentials(bncNetwork.connection.password),
          _this$parseBncCredent2 = (0, _slicedToArray2.default)(_this$parseBncCredent, 2),
          username = _this$parseBncCredent2[0],
          password = _this$parseBncCredent2[1];
        this.bnc.username = username;
        this.bnc.password = password;
      }

      // Enable BOUNCER on existing connections
      this.state.networks.forEach(function (network) {
        network.ircClient.use((0, _BouncerMiddleware.default)());
      });

      // this.monitorNetworkChanges();
      this.listenToState();
    }

    // Try to get a connected network that can be used to control the bouncer
  }, {
    key: "getController",
    value: function getController() {
      if (this.controllerNetwork && this.controllerNetwork.state === 'connected') {
        return this.controllerNetwork;
      }
      this.controllerNetwork = null;
      for (var i = 0; i < this.state.networks.length; i++) {
        var network = this.state.networks[i];
        var client = network.ircClient;
        if (network.state === 'connected' && client.network.cap.isEnabled('bouncer')) {
          this.controllerNetwork = network;
          break;
        }
      }
      return this.controllerNetwork;
    }
  }, {
    key: "onNetworkMotd",
    value: function () {
      var _onNetworkMotd = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(event, network) {
        var client, _this$parseBncCredent3, _this$parseBncCredent4, username, password;
        return _regenerator.default.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              client = network.ircClient;
              if (this.bnc.enabled) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return");
            case 1:
              if (client.network.cap.isEnabled('bouncer')) {
                _context3.next = 2;
                break;
              }
              log.debug("BOUNCER cap not available on network ".concat(network.name, ", not using for BNC"));
              return _context3.abrupt("return");
            case 2:
              // Set the bncnetid if the network upstream exists and we havn't already set it
              if (client.bnc.hasNetwork() && !network.connection.bncnetid) {
                network.connection.bncnetid = client.bnc.tags().netid;
              }

              // Use this initial network password for other network connections
              if (!this.bnc.username) {
                _this$parseBncCredent3 = this.parseBncCredentials(network.connection.password), _this$parseBncCredent4 = (0, _slicedToArray2.default)(_this$parseBncCredent3, 2), username = _this$parseBncCredent4[0], password = _this$parseBncCredent4[1];
                this.bnc.username = username;
                this.bnc.password = password;
              }

              // If this is a BNC network, sync it before anything else so that we get all its info
              // and buffer states as soon as possible
              if (!client.bnc.hasNetwork()) {
                _context3.next = 3;
                break;
              }
              _context3.next = 3;
              return this.syncBncNetwork(network);
            case 3:
              if (network.connection.bncnetid) {
                _context3.next = 4;
                break;
              }
              _context3.next = 4;
              return this.initAndAddNetworks(network);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee, this);
      }));
      function onNetworkMotd(_x, _x2) {
        return _onNetworkMotd.apply(this, arguments);
      }
      return onNetworkMotd;
    }()
  }, {
    key: "onNetworkState",
    value: function onNetworkState(event, network) {
      var isController = this.getController() === network;
      // We get connection state changes advertised on all bouncer connections, so only handle
      // the ones that come from the controller network since we only need to deal with it once.
      if (isController && event.state === 'disconnected') {
        // Mimick any network disconnections by closing this connection too
        var effectedNetwork = this.state.getNetworkFromBncNetId(event.networkId);
        if (effectedNetwork) {
          effectedNetwork.ircClient.connection.transport.close();
        }
      }
    }
  }, {
    key: "initAndAddNetworks",
    value: function () {
      var _initAndAddNetworks = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(network) {
        var client;
        return _regenerator.default.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              client = network.ircClient;
              this.bnc.registered = true;

              // hide the empty (non-network) controller network
              if (!network.ircClient.bnc.hasNetwork()) {
                network.hidden = true;
                network.is_bnc = true;
              } else {
                network.hidden = false;
                network.is_bnc = false;
              }

              // onBouncerNetworks will pick up the event handler for this
              client.bnc.getNetworks();
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee2, this);
      }));
      function initAndAddNetworks(_x3) {
        return _initAndAddNetworks.apply(this, arguments);
      }
      return initAndAddNetworks;
    }()
  }, {
    key: "onBouncerNetworks",
    value: function onBouncerNetworks(bncNetworks) {
      var _this = this;
      log.debug("Got ".concat(bncNetworks.length, " networks from the BNC"), bncNetworks);
      bncNetworks.forEach(function (bncNet) {
        return _this.addNetworkToState(bncNet);
      });

      // Remove any networks we have locally but no longer exist on the BNC
      this.state.networks.forEach(function (existingNet) {
        var isNetworkInBncList = !!(0, _find.default)(bncNetworks).call(bncNetworks, function (n) {
          return n.networkId === existingNet.connection.bncnetid;
        });
        if (!existingNet.is_bnc && !isNetworkInBncList) {
          var _context5;
          log.debug((0, _concat.default)(_context5 = "Network '".concat(existingNet.name, "' (")).call(_context5, existingNet.id, ") was not in the BNC, removing locally"));
          _this.state.removeNetwork(existingNet.id);
        }
      });

      // start monitoring network changes
      this.monitorNetworkChanges();
      if (this.state.getActiveBuffer()) {
        return;
      }
      if (!bncNetworks.length) {
        // BNC has no network, lets add one to help the user
        var net = this.state.addNetwork('Network', '', {});
        net.showServerBuffer('settings');
      } else {
        for (var i = 0; i < this.state.networks.length; i++) {
          var _net = this.state.networks[i];
          if (!_net.is_bnc) {
            // The first network that is not the BNC control network
            _net.showServerBuffer('settings');
            break;
          }
        }
      }
    }
  }, {
    key: "syncBncNetwork",
    value: function () {
      var _syncBncNetwork = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3(bncNetwork) {
        var _this2 = this;
        var client, buffers;
        return _regenerator.default.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              client = bncNetwork.ircClient;
              log.debug("Syncing network ".concat(bncNetwork.name, " from the BNC"));
              _context7.next = 1;
              return client.bnc.getBuffers(bncNetwork.connection.bncnetid);
            case 1:
              buffers = _context7.sent;
              buffers.forEach(function (buffer) {
                // The list of buffers also include the network name. Make use of it and make sure our
                // network name is up to date while we can. It may have changed elsewhere
                if (bncNetwork.name !== buffer.network) {
                  var _context6;
                  log((0, _concat.default)(_context6 = "Detected network name change while syncing buffers. ".concat(bncNetwork.name, " > ")).call(_context6, buffer.network));
                  bncNetwork.name = buffer.network;
                }
                var newBuffer = _this2.state.addBuffer(bncNetwork.id, buffer.name);
                if (!newBuffer) {
                  // The BNC might be giving up bad buffer names or something, so just make sure
                  // that it's handled if it ever coccurs
                  log.error("Couldn't add BNC buffer, '".concat(buffer.name, "'"), buffer);
                  return;
                }
                if (buffer.joined) {
                  newBuffer.enabled = true;
                  newBuffer.joined = true;
                } else {
                  newBuffer.enabled = false;
                  newBuffer.joined = false;
                }
                if (buffer.seen) {
                  newBuffer.last_read = new Date(buffer.seen).getTime();
                }
                if (buffer.notify) {
                  newBuffer.setting('alert_on', buffer.notify);
                }
                newBuffer.topic = buffer.topic || '';
                if (bncNetwork.state === 'connected' && newBuffer.isChannel() && newBuffer.joined) {
                  client.raw('NAMES ' + newBuffer.name);
                  client.who(newBuffer.name);
                }
              });

              // Remove any existing buffers that we no longer have on the bouncer
              bncNetwork.buffers.forEach(function (clientBuffer) {
                if (!clientBuffer.isChannel() && !clientBuffer.isQuery()) {
                  return;
                }
                var existingBuffers = (0, _filter.default)(buffers).call(buffers, function (bncBuffer) {
                  return bncBuffer.name.toLowerCase() === clientBuffer.name.toLowerCase();
                });
                if (existingBuffers.length === 0) {
                  _this2.state.removeBuffer(clientBuffer);
                }
              });
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee3);
      }));
      function syncBncNetwork(_x4) {
        return _syncBncNetwork.apply(this, arguments);
      }
      return syncBncNetwork;
    }()
  }, {
    key: "addNetworkToState",
    value: function () {
      var _addNetworkToState = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4(network) {
        var net;
        return _regenerator.default.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              // Expects network to be in the format of:
              //  {
              //  "networkId":"xyz",
              //  "name":"freenode",
              //  "channel":"1",
              //  "connected":"1",
              //  "host":"irc.freenode.net",
              //  "port":"6667",
              //  "tls":"0",
              //  "nick":"notprawn99829"
              //  },
              net = this.state.getNetworkFromBncNetId(network.networkId);
              if (!net) {
                net = this.state.addNetwork(network.name, network.nick || '', {
                  server: network.host,
                  port: network.port,
                  tls: network.tls,
                  password: network.password || '',
                  bncnetid: network.networkId,
                  username: network.user,
                  account_password: network.account_password
                });
              } else {
                // Make sure our existing network is all up to date
                net.name = network.name;
                net.connection.server = network.host;
                net.connection.port = parseInt(network.port, 10);
                net.connection.tls = network.tls;
                net.connection.nick = network.account || network.nick;
                net.connection.password = network.password || '';
                net.nick = network.currentNick || network.nick || '';
                net.password = network.account_password;
              }
              net.editable_name = true;
              return _context8.abrupt("return", net);
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee4, this);
      }));
      function addNetworkToState(_x5) {
        return _addNetworkToState.apply(this, arguments);
      }
      return addNetworkToState;
    }() // Keep a snapshot of what the current networks are. They will be periodically
    // compared with the active networks to see if anything has changed before
    // saving those changes.
  }, {
    key: "snapshotCurrentNetworks",
    value: function snapshotCurrentNetworks() {
      var _this3 = this;
      this.networksSnapshot = Object.create(null);
      this.state.networks.forEach(function (network) {
        if (!network.connection.bncnetid) {
          return;
        }
        _this3.networksSnapshot[network.connection.bncnetid] = {
          bncnetid: network.connection.bncnetid,
          network: network.name,
          host: network.connection.server,
          port: network.connection.port,
          tls: network.connection.tls,
          account: network.connection.nick,
          account_password: network.password,
          server_password: network.connection.password,
          nick: network.connection.nick,
          username: network.username
        };
      });
    }

    // Compare the current networks with our previously saved snapshot of
    // networks. Save any changes to the bouncer
  }, {
    key: "saveState",
    value: function saveState() {
      var _this4 = this;
      var controller = this.getController();
      if (!controller) {
        log.debug('No controller available to save networks');
        return;
      }
      this.state.networks.forEach(function (network) {
        // don't save an empty controller to the network.
        // we can't use hasNetwork alone because that requires ircClient to be
        //  connected, and we save new nets before they are connected
        if (_this4.getController() === network && !network.ircClient.bnc.hasNetwork()) {
          return;
        }

        // Don't save any hidden networks. This includes the BNC controller network
        if (network.hidden) {
          return;
        }

        // Every network needs a valid name
        if (!network.name.match(/^[a-zA-Z_0-9.]+$/)) {
          log.debug("Network ".concat(network.id, " has an invalid name. Not saving to the BNC"));
          return;
        }
        var bncnetid = network.connection.bncnetid;
        var snapshot = _this4.networksSnapshot[bncnetid] || {};
        var tags = {};
        if (network.name !== snapshot.network) {
          tags.network = network.name;
        }
        if (network.connection.server !== snapshot.host) {
          tags.host = network.connection.server;
        }
        if (network.connection.port !== snapshot.port) {
          tags.port = network.connection.port;
        }
        if (network.connection.tls !== snapshot.tls) {
          tags.tls = network.connection.tls;
        }
        if (network.password !== snapshot.account_password) {
          tags.account_password = network.password;
        }
        if (network.connection.nick !== snapshot.account) {
          tags.account = network.connection.nick;
        }
        if (network.connection.password !== snapshot.server_password) {
          tags.password = network.connection.password;
        }
        if (network.connection.nick !== snapshot.nick) {
          tags.nick = network.connection.nick;
        }
        if (network.username !== snapshot.username) {
          tags.user = network.username;
        }

        // A newly added network would not have a snapshot name (bncnetid) property set yet.
        // Only save the network if we've entered connection info.
        if (!snapshot.bncnetid && tags.host && tags.port && tags.nick) {
          log("Saving new network ".concat(network.name, " to the BNC"));
          // ?? network.connection.bncname = network.name;
          controller.ircClient.bnc.addNetwork(network.name, tags.host, tags.port, tags.tls, tags.nick, tags.user, tags.password).then(function (networkInfo) {
            network.connection.bncnetid = networkInfo.networkId;
            network.name = networkInfo.network;
          });
        } else if (snapshot.bncnetid && (0, _keys.default)(tags).length > 0) {
          log("Updating network ".concat(network.name, " on the BNC"));
          controller.ircClient.bnc.saveNetwork(bncnetid, tags);
        }
      });
      this.snapshotCurrentNetworks();
    }
  }, {
    key: "monitorNetworkChanges",
    value: function monitorNetworkChanges() {
      if (this.monitoringChanges) {
        return;
      }
      this.monitoringChanges = true;
      this.snapshotCurrentNetworks();
      var debouncedSaveState = _lodash.default.debounce(this.saveState.bind(this), 2000);
      this.state.$watch('networks', debouncedSaveState, {
        deep: true
      });
    }
  }, {
    key: "listenToState",
    value: function listenToState() {
      var _this5 = this;
      var state = this.state;

      // Just before we connect to a network, make sure the BNC is saved and connected to
      // it or at least trying to connect.
      // Ie. Quickly creating a network and hitting connect before it's had time to
      //     save itself to the bouncer
      state.$on('network.connecting', function (event) {
        // Redirect the connection towards the bouncer with the network specific password
        var network = event.network;
        if (_this5.bnc.enabled && _this5.rewriteConnections) {
          var netname = network.name;
          var ircClient = network.ircClient;
          ircClient.options.host = _this5.bnc.server;
          ircClient.options.port = _this5.bnc.port;
          ircClient.options.tls = _this5.bnc.tls;

          // Only re-write the server password for non-bnc controller networks
          if (_this5.bnc.password && !event.network.is_bnc) {
            var _context9, _context0;
            var password = (0, _concat.default)(_context9 = (0, _concat.default)(_context0 = "".concat(_this5.bnc.username, "/")).call(_context0, netname, ":")).call(_context9, _this5.bnc.password);
            ircClient.options.password = password;
          }

          // The SASL auth already happens on the BNC, we only use it for UI purposes in kiwi
          ircClient.options.account = {};
          network.connection.direct = _this5.bnc.direct;
          ircClient.options.path = _this5.bnc.path;
        }
      });
      state.$on('network.connecting', function (event) {
        var controller = _this5.getController();
        if (!controller) {
          log.debug('No controller available to save network states');
          return;
        }
        _this5.saveState();
        var network = event.network;
        if (network.connection.bncnetid) {
          controller.ircClient.raw('BOUNCER connect ' + network.connection.bncnetid);
        }
      });
      state.$on('irc.motd', function (event, network) {
        network.buffers.forEach(function (buffer) {
          if (buffer.isChannel() && buffer.enabled && buffer.joined) {
            network.ircClient.who(buffer.name);
          }
        });
      });
      state.$on('network.new', function (event) {
        var network = event.network;

        // Enable BOUNCER on this connection
        network.ircClient.use((0, _BouncerMiddleware.default)());
        network.editable_name = true;

        // If network is attached to a bouncer do nothing
        // (use the name provided by the bouncer)
        if (network.connection.bncnetid) {
          return;
        }
        var existingNet = true;

        // append a number to the network name. E.g. "Network, Network2,..."
        // while there is a network with that name
        var currentNum = 1;
        var tryNetworkName;
        while (existingNet) {
          if (network.name && currentNum === 1) {
            // don't append the number 1 if there is a custom name
            tryNetworkName = network.name;
          } else {
            tryNetworkName = (network.name || 'Network') + currentNum;
          }
          existingNet = (0, _find.default)(_lodash.default).call(_lodash.default, state.networks, {
            name: tryNetworkName
          });
          if (!existingNet || existingNet === network) {
            network.name = tryNetworkName;
            break;
          }
          currentNum++;
        }
      });
      state.$on('network.removed', function (event) {
        var controller = _this5.getController();
        if (!controller) {
          log.debug('No controller available to save network states');
          return;
        }
        if (event.network.connection.bncnetid) {
          controller.ircClient.bnc.removeNetwork(event.network.connection.bncnetid);
        }
      });
      state.$on('buffer.close', function (event) {
        var buffer = event.buffer;
        var network = event.buffer.getNetwork();
        var bncnetid = network.connection.bncnetid;
        var controller = _this5.getController();
        if (!controller) {
          log.debug('No controller available to save buffer states');
          return;
        }
        if (bncnetid) {
          controller.ircClient.bnc.closeBuffer(bncnetid, buffer.name);
        }
      });
    }
  }, {
    key: "parseBncCredentials",
    value: function parseBncCredentials(bncNetworkPassword) {
      var _bncNetworkPassword$s = bncNetworkPassword.split(':'),
        _bncNetworkPassword$s2 = (0, _slicedToArray2.default)(_bncNetworkPassword$s, 2),
        username = _bncNetworkPassword$s2[0],
        password = _bncNetworkPassword$s2[1];
      username = username.split('/')[0];
      return [username, password];
    }
  }]);
}();
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["BouncerProvider"]
window._kiwi_exports.libs.BouncerProvider = exports.default ? exports.default : exports;
